import React from 'react';

import { Box, BoxProps } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

interface Props extends BoxProps {
  children: React.ReactNode;
}

export const FilterLabelWrapper: React.FC<Props> = props => {
  const { children, ...rest } = props;
  return (
    <Box
      py={1}
      px={2}
      border="1px solid"
      borderColor="componentBorder"
      borderRadius={6}
      color={customTheme.colors.gray['300']}
      bg={colorOpacity(customTheme.colors.gray['200'], 0.2)}
      whiteSpace="nowrap"
      fontSize="15px"
      fontWeight={400}
      {...rest}
    >
      {children}
    </Box>
  );
};
